import type { App } from 'vue';
import type { IApplicationInsights } from '@microsoft/applicationinsights-web';
import type { Router } from 'vue-router';
import { setupPageTracking } from './trackers/vue-router';
import { appInsightsInjectionKey } from './symbols';

export type Options = {
    appInsights: IApplicationInsights;
    router?: Router | false;
    appName?: string;
};

declare module 'vue' {
    interface ComponentCustomProperties {
        $appInsights: IApplicationInsights;
    }
}

export default {
    install(app: App, options: Options) {
        const appInsights = options.appInsights;
        app.config.globalProperties.$appInsights = appInsights;
        app.provide(appInsightsInjectionKey, appInsights);

        const router = options.router ?? app.config.globalProperties.$router;
        if (router) {
            setupPageTracking(
                router,
                appInsights,
                options.appName ?? 'Vue App'
            );
        }
    },
};
